import SendIcon from "@mui/icons-material/Send";
import TuneIcon from "@mui/icons-material/Tune";
import { IconButton, InputBase, Paper, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import { useCustomThemeContext } from "../lib/contexts/ThemeContext";
import { useChatSessionsContext } from "../lib/contexts/ChatSessionsContext";

interface InputAreaProps {
  currentMessage: string;
  disabled: boolean;
  handleSubmit: any;
  handleInputChange: any;
  handleChatFilterClick: any;
}

export default function InputArea(props: InputAreaProps) {
  const { custom } = useCustomThemeContext();
  const context = useChatSessionsContext();
  const { inputRef } = context;

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        marginTop: "1%",
        paddingLeft: "60px",
        justifyContent: "left",
        alignContent: "center",
      }}
    >
      {/* Textfield section */}
      <Paper
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "center",
          width: "95%",
          borderRadius: "30px",
          height: "5vh",
        }}
        // calls handleSubmit function when user either hits "Enter" or clicks on the submit icon button
        onSubmit={props.handleSubmit}
      >
        <InputBase
          value={props.currentMessage}
          onChange={props.handleInputChange} // when user enters text, handleInputChange is called to update currentMessage
          sx={{ width: "100%", paddingLeft: "15px" }}
          placeholder="Send a message"
          inputProps={{ "aria-label": "Send a message" }}
          inputRef={inputRef} // Attach the ref to the InputBase
        />
        <Tooltip title="Metadata Filters">
          <IconButton
            sx={{ p: "2%" }}
            aria-label="directions"
            onClick={props.handleChatFilterClick}
            disabled={props.disabled}
          >
            <TuneIcon
              sx={{
                color: props.disabled
                  ? "rgba(0, 0, 0, 0.26)"
                  : custom.palette.secondary.light,
              }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title="Send Message">
          <IconButton
            sx={{ p: "2%" }}
            aria-label="directions"
            type="submit"
            disabled={props.disabled}
          >
            <SendIcon
              sx={{
                color: props.disabled
                  ? "rgba(0, 0, 0, 0.26)"
                  : custom.palette.secondary.light,
              }}
            />
          </IconButton>
        </Tooltip>
      </Paper>
    </Box>
  );
}
